import axios from './base';
import { LOGIN_API, ME_API } from './constants';

export const login = (params) => axios.post(LOGIN_API, params);
export const auth = () => axios.get(ME_API);
